import { TypedUseSelectorHook, useSelector } from "react-redux"

import { RootState } from "../redux/store"

// Typed version of redux `useSelector` hook
export const useGetState: TypedUseSelectorHook<RootState> = useSelector
